import React from 'react';
import {Link, NavLink, Route, Routes} from "react-router-dom";
import Register from "./Register";
import ManageGameGeneral from "./ManageGame/ManageGameGeneral";
import Subscriptions from "./Subscribe/Subscriptions";
import GameChat from "./Chat/GameChat";
import GameChats from "./Chat/GameChats";
import Profile from "./Account/Profile";

export default class Account extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoadedDownloads: false,
            isLoadedLibrary: false,
            isLoadedFavourites: false,
            isLoadedGeneralInfo: false,
            subscriptions: [],
            isSubscriptionsLoaded: false,
            downloads: [],
            library: [],
            favourites: [],
            generalInfo: [],
            isLoadedTeamMemberCompanies: false,
            teamMemberCompanies: [],
        };
    }

    componentDidMount() {
        console.log(JSON.stringify(this.props));
        console.log(sessionStorage.getItem('token'));
        if(this.props.userId) {
            fetch(process.env.REACT_APP_API_URL + "/customer/" + this.props.userId, {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoadedGeneralInfo: true,
                            generalInfo: result.data
                        });
                    },

                    (error) => {
                        this.setState({
                            isLoadedGeneralInfo: true,
                            error
                        });
                    }
                )

            console.log(this.state.subscriptions);

            fetch(process.env.REACT_APP_API_URL + "/customer/downloaded-now?user_id=" + this.props.userId, {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoadedDownloads: true,
                            downloads: result.data
                        });
                    },

                    (error) => {
                        this.setState({
                            isLoadedDownloads: true,
                            error
                        });
                    }
                )

            fetch(process.env.REACT_APP_API_URL + "/customer/downloaded-all-time?user_id=" + this.props.userId, {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoadedLibrary: true,
                            library: result.data
                        });
                    },

                    (error) => {
                        this.setState({
                            isLoadedLibrary: true,
                            error
                        });
                    }
                )

            fetch(process.env.REACT_APP_API_URL + "/customer/favourites?user_id=" + this.props.userId, {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoadedFavourites: true,
                            favourites: result.data
                        });
                    },

                    (error) => {
                        this.setState({
                            isLoadedFavourites: true,
                            error
                        });
                    }
                )

            fetch(process.env.REACT_APP_API_URL + "/publisher/company/team-member/" + this.props.userId,{
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoadedTeamMemberCompanies: true,
                            teamMemberCompanies: result
                        });
                    },

                    (error) => {
                        this.setState({
                            isLoadedTeamMemberCompanies: true,
                            error
                        });
                    }
                )
        }
    }

    login(e) {
        e.preventDefault();

        //TODO: implement subscribe/unsubscribe
    }

    register(e) {
        e.preventDefault();

        //TODO: implement subscribe/unsubscribe
    }

    render() {
        let generalInfoFormatted = [];

        const { error, isLoadedDownloads, downloads } = this.state;
        const { errorLibrary, isLoadedLibrary, library } = this.state;
        const { errorFavourites, isLoadedFavourites, favourites } = this.state;
        const { errorGeneralInfo, isLoadedGeneralInfo, generalInfo, teamMemberCompanies, isLoadedTeamMemberCompanies } = this.state;

        if (errorGeneralInfo || errorLibrary || errorFavourites || error) {
            generalInfoFormatted = <div>Error: {errorGeneralInfo.message}</div>;
        } else if (!isLoadedFavourites || !isLoadedDownloads || !isLoadedLibrary || !isLoadedGeneralInfo || !isLoadedTeamMemberCompanies) {
            generalInfoFormatted = <div>Loading...</div>;
        } else {
            generalInfoFormatted = (
                <div>
                    <Profile teamMemberCompanies={teamMemberCompanies} user={generalInfo} downloads={downloads} favourites={favourites} library={library}/>

                    <br/>
                </div>
            );
        }

        return <div>
            <br/>

            {generalInfoFormatted}

            <br/>
            <NavLink to={{
                pathname: '/account/'+this.props.userId.toString()+'/payment',
            }} className="btn btn-danger">
                Billing portal
            </NavLink>
            <br/>
        </div>;
    }
}
